import { render, staticRenderFns } from "./StokListesiResimTab.vue?vue&type=template&id=5a41d6d3"
import script from "./StokListesiResimTab.vue?vue&type=script&lang=js"
export * from "./StokListesiResimTab.vue?vue&type=script&lang=js"
import style0 from "./StokListesiResimTab.vue?vue&type=style&index=0&id=5a41d6d3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports